




import { defineComponent } from "@vue/composition-api";
import OccBreadcrumbs, {
  BreadcrumbRoute
} from "@/components/Atoms/OccBreadcrumbs/index.vue";

export default defineComponent({
  name: "UniversityCard",
  components: {
    OccBreadcrumbs
  },
  setup() {
    const breadcrumbRoute: BreadcrumbRoute[] = [
      {
        label: "設定",
        disabled: true
      },
      {
        label: ""
      }
    ];

    return {
      breadcrumbRoute
    };
  }
});
